import React, { useEffect, useState } from 'react';
import Logo from '../../elements/logo/Logo';
import { Link } from 'react-router-dom';
import {
    FaFacebookF, FaLinkedin, FaInstagram, FaMailBulk, FaPhoneAlt
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ServiceData from "../../data/service/ServiceMain.json";
import { slugify } from '../../utils';

const getServiceData = ServiceData;

const FooterOne = ({ parentClass }) => {
    const [isVisible, setIsVisible] = useState(false);

    // show button when scroll more than 200px
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    // smooth scroll to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    // Inline styles for the scroll-up image
    const scrollBtnStyle = {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    width: '50px',
    height: '50px',
    cursor: 'pointer',
    zIndex: 9999,
    opacity: isVisible ? 1 : 0,
    visibility: isVisible ? 'visible' : 'hidden',
    transition: 'all 0.4s ease-in-out',
    filter: 'drop-shadow(0 3px 6px rgba(0,0,0,0.25))',
    transform: isVisible ? 'translateY(0)' : 'translateY(15px)',
    borderRadius: '50%', // 🔥 Makes it perfectly circular
    backgroundColor: '#ffffff', // optional – to make it visible if PNG has transparency
};


    return (
        <footer className={`footer-area ${parentClass}`}>
            <div className="container">
                <div className="footer-main">
                    <div className="row">
                        <div className="col-xl-6 col-lg-5">
                            <div className="footer-widget border-end">
                                <div className="footer-newsletter">
                                    <div className="header-logo">
                                        <Logo limage="/images/gfy_logo.png" />
                                    </div>
                                    <p>
                                        Graphify offer various kinds of products and services to the public and business firms to boost up their portfolio level. We nurture personal growth for our team by creating a challenging environment with opportunities.
                                    </p>
                                </div>
                                <div className="footer-top">
                                    <div className="footer-social-link">
                                        <ul className="list-unstyled">
                                            <li><Link to="#"><FaFacebookF /></Link></li>
                                            <li><Link to="#"><FaXTwitter /></Link></li>
                                            <li><Link to="#"><FaLinkedin /></Link></li>
                                            <li><Link to="#"><FaInstagram /></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-7">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="footer-widget">
                                        <h6 className="widget-title">Quick Links</h6>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                                <li><Link to={"/Home"}>Home</Link></li>
                                                <li><Link to={"/about-us"}>About Us</Link></li>
                                                <li><Link to={"/services"}>Service</Link></li>
                                                <li><Link to={"/projects"}>Projects</Link></li>
                                                <li><Link to={"/team"}>Team</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="footer-widget">
                                        <h6 className="widget-title">Address</h6>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                                <p>36D, Veerakeralam Road, Vadavalli, Thirumurugan Nagar, Coimbatore, Tamil Nadu – 641041, India.</p>
                                            </ul>
                                            <ul className="list-unstyled">
                                                <li><Link to="/contact"><FaMailBulk /> info@graphifyinfotech.com</Link></li>
                                                <li><Link to="/contact"><FaPhoneAlt /> +91 90428 956997</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-3">
                                    <div className="footer-widget">
                                        <h6 className="widget-title">Support</h6>
                                        <div className="footer-menu-link">
                                            <ul className="list-unstyled">
                                                <li><Link to={"/contact"}>Contact</Link></li>
                                                <li><Link to={"/privacy-policy"}>Privacy Policy</Link></li>
                                                <li><Link to={"/terms-use"}>Terms of Use</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="footer-copyright">
                                <span className="copyright-text">
                                    © {new Date().getFullYear()}. All rights reserved by <a href="#">GRAPHIFY INFOTECH</a>.
                                </span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="footer-bottom-link">
                                <ul className="list-unstyled">
                                    <li><Link to={"/privacy-policy"}>Privacy Policy</Link></li>
                                    <li><Link to={"/terms-use"}>Terms of Use</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scroll to Top Image with inline styles */}
            <img
                src="/images/banner/up_arrow.png"
                alt="Back to top"
                style={scrollBtnStyle}
                onClick={scrollToTop}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px) scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            />
        </footer>
    );
};

export default FooterOne;
